(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 23855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 57671:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(__webpack_require__(67294));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AccountKeyIcon = function AccountKeyIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.className || '');

  return React.createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React.createElement('path', { d: 'M11,10V12H10V14H8V12H5.83C5.42,13.17 4.31,14 3,14A3,3 0 0,1 0,11A3,3 0 0,1 3,8C4.31,8 5.42,8.83 5.83,10H11M3,10A1,1 0 0,0 2,11A1,1 0 0,0 3,12A1,1 0 0,0 4,11A1,1 0 0,0 3,10M16,14C18.67,14 24,15.34 24,18V20H8V18C8,15.34 13.33,14 16,14M16,12A4,4 0 0,1 12,8A4,4 0 0,1 16,4A4,4 0 0,1 20,8A4,4 0 0,1 16,12Z' })
  );
};

var AccountKeyIcon$1 = React.memo ? React.memo(AccountKeyIcon) : AccountKeyIcon;

module.exports = AccountKeyIcon$1;


/***/ }),

/***/ 97106:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(63261);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ HelpLink; },
/* harmony export */   "JP": function() { return /* binding */ RegisterContactUsLink; },
/* harmony export */   "jz": function() { return /* binding */ IdentificationContactUsLink; },
/* harmony export */   "Jr": function() { return /* binding */ CompanyContactUsLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var mdi_react_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45635);
/* harmony import */ var mdi_react_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mdi_react_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var mdi_react_InfoOutlineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2072);
/* harmony import */ var mdi_react_InfoOutlineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mdi_react_InfoOutlineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74815);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83852);







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  &:last-child a {\n    margin-bottom: 0;\n  }\n\n  a {\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n    color: ",
        ";\n\n    svg:not(:first-child) {\n      margin-left: 0.4rem;\n    }\n\n    svg:first-child {\n      margin-top: 0;\n      margin-right: 0.4rem;\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4bab1975-0"
})(_templateObject1(), _components_Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.white */ .Il.white, _components_Theme__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .lighten */ .$n)(0.1, _components_Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.black */ .Il.black))));
var HelpLink = function(param) {
    var href = param.href, _style = param.style, style = _style === void 0 ? {} : _style, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
            href: href,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                style: style,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_InfoOutlineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
                        size: 16,
                        color: _components_Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.primary */ .Il.primary
                    }),
                    " ",
                    children,
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
                        size: 16
                    })
                ]
            })
        })
    });
};
var RegisterContactUsLink = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpLink, {
        href: "/contact-us#register",
        children: "Kysytt\xe4v\xe4\xe4 rekister\xf6itymisest\xe4? Ota yhteytt\xe4"
    });
};
var IdentificationContactUsLink = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpLink, {
        href: "/contact-us#identification",
        children: "Kysytt\xe4v\xe4\xe4 tunnistautumisesta? Ota yhteytt\xe4"
    });
};
var CompanyContactUsLink = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpLink, {
        href: "/contact-us#company",
        children: "Kysytt\xe4v\xe4\xe4 yrityksen liitt\xe4misest\xe4? Ota yhteytt\xe4"
    });
};


/***/ }),

/***/ 63261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(33426);
// EXTERNAL MODULE: ./node_modules/mdi-react/AccountKeyIcon.js
var AccountKeyIcon = __webpack_require__(57671);
var AccountKeyIcon_default = /*#__PURE__*/__webpack_require__.n(AccountKeyIcon);
// EXTERNAL MODULE: ./context/loginContext.tsx
var loginContext = __webpack_require__(9000);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./components/auth/HelpLink.tsx
var HelpLink = __webpack_require__(30045);
// EXTERNAL MODULE: ./components/SEO.tsx
var SEO = __webpack_require__(81476);
// EXTERNAL MODULE: ./components/auth/AuthLayout.tsx
var AuthLayout = __webpack_require__(25796);
// EXTERNAL MODULE: ./components/Theme.ts
var Theme = __webpack_require__(74815);
;// CONCATENATED MODULE: ./components/Or.tsx




function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px 0;\n  width: 100%;\n\n  &::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    background-color: ",
        ";\n  }\n\n  > span {\n    padding: 0 8px;\n    background-color: ",
        ";\n    color: ",
        ";\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-466aff9a-0"
})(_templateObject(), Theme/* Color.background */.Il.background, Theme/* Color.white */.Il.white, Theme/* Color.disabled */.Il.disabled);
var Or = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "orDivider",
                defaultMessage: "Tai"
            })
        })
    }));
};

// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/Error.tsx
var Error = __webpack_require__(89649);
// EXTERNAL MODULE: ./components/auth/AuthLoginPoll.tsx
var AuthLoginPoll = __webpack_require__(88791);
;// CONCATENATED MODULE: ./pages/login/index.tsx
















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function login_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function login_templateObject() {
    var data = login_taggedTemplateLiteral([
        "\n  margin-left: 0 !important;\n  padding: 22px !important;\n  width: 100%;\n  border-radius: ",
        "px !important;\n"
    ]);
    login_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = login_taggedTemplateLiteral([
        "\n  margin-top: 32px !important;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = login_taggedTemplateLiteral([
        "\n  position: relative;\n\n  ::after {\n    content: '';\n    display: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var LargeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-95dc46a1-0"
})(login_templateObject(), Theme/* borderRadius */.E0 * 3);
var LargeSubmitButton = (0,styled_components_browser_esm/* default */.ZP)(LargeButton).withConfig({
    componentId: "sc-95dc46a1-1"
})(_templateObject1());
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-95dc46a1-2"
})(_templateObject2(), function(param) {
    var $polling = param.$polling;
    return $polling ? 'block' : 'none';
}, Theme/* Color.disabled */.Il.disabled, Theme/* borderRadius */.E0);
var Login = function() {
    var ref4 = (0,react.useState)(''), email = ref4[0], setEmail = ref4[1];
    var ref1 = (0,react.useState)(null), error1 = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), token1 = ref2[0], setToken = ref2[1];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var handleValidate = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var ref, status, error, token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        setIsLoading(true);
                        setError(null);
                        _ctx.next = 6;
                        return (0,loginContext/* loginUser */.pH)({
                            email: email
                        });
                    case 6:
                        ref = _ctx.sent;
                        status = ref.status;
                        error = ref.error;
                        token = ref.token;
                        if (!(status !== 'ok')) {
                            _ctx.next = 13;
                            break;
                        }
                        setIsLoading(false);
                        return _ctx.abrupt("return", setError(error));
                    case 13:
                        setToken(token);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loginContext/* loginUser */.pH,
        setError,
        email
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* LoginPage */.Xs, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthLayout/* AuthLayout */.g, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "register.loginDialog.title",
                    defaultMessage: "Kirjaudu sis\xe4\xe4n"
                }),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "register.loginDialog.subtitle",
                    defaultMessage: "Kirjaudu sis\xe4\xe4n Constleen s\xe4hk\xf6postiin saapuvan kirjautumislinkin avulla."
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((AccountKeyIcon_default()), {}),
                control: false,
                width: 500,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpLink/* HelpLink */.BQ, {
                        href: "/contact-us",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "register.dialog.helpLink",
                            defaultMessage: "Apua kirjautumiseen"
                        })
                    })
                }),
                children: [
                    !token1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                        $polling: !!token1,
                        onSubmit: handleValidate,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "register.form.email",
                                    defaultMessage: "S\xe4hk\xf6postiosoite"
                                }),
                                variant: "outlined",
                                type: "email",
                                autoComplete: "username",
                                onChange: function(event) {
                                    return setEmail(event.target.value);
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* Error */.j, {
                                error: error1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeSubmitButton, {
                                type: "submit",
                                loading: isLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "register.loginDialog.loginButton",
                                    defaultMessage: "L\xe4het\xe4 kirjautumislinkki"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Or, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LargeButton, {
                                type: "submit",
                                color: "default",
                                loading: isLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "register.dialog.registerLink",
                                    defaultMessage: "Luo uusi tili & aloita 14-p\xe4iv\xe4n kokeilu"
                                })
                            })
                        ]
                    }),
                    !!token1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLoginPoll/* AuthLoginPoll */.X, {
                        token: token1
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var login = (Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [929,5796,1476,9774,2888,179], function() { return __webpack_exec__(97106); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);